"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  notify: {
    position: 'fixed',
    top: 0,
    right: 0,
    zIndex: 2147483647,
    width: theme.notify.width,
    padding: `0 ${theme.notify.padding}px`,
    maxHeight: '100vh'
  },
  animEnter: {
    transform: 'translateY(-100px)'
  },
  animEnterActive: {
    transform: 'translateY(0)',
    transition: 'all 500ms ease-in'
  },
  animExit: {
    transform: 'translateY(0)'
  },
  animExitActive: {
    transition: 'all 500ms ease-in',
    transform: 'translateY(-100px)',
    opacity: 0
  }
});

exports.default = _default;